'use client'

import { useEffect } from 'react'
import {
  type CLSMetricWithAttribution,
  type INPMetricWithAttribution,
  type LCPMetricWithAttribution,
  type Metric,
  onCLS,
  onFCP,
  onINP,
  onLCP,
  onTTFB,
} from 'web-vitals/attribution'

const ENDPOINT = '/api/rum/web-vitals'

// Never send full URLs, user identifiers or other PII here.
function sendVital(metric: Metric) {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') {
    return
  }

  const body: Record<string, unknown> = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
    path: window.location.pathname,
  }

  if (metric.name === 'LCP') {
    const { target, url, lcpResourceEntry } = (metric as LCPMetricWithAttribution).attribution
    body.target = target
    body.resourceUrl = url
    body.resourceSizeBytes = lcpResourceEntry?.transferSize
  }

  if (metric.name === 'CLS') {
    body.target = (metric as CLSMetricWithAttribution).attribution.largestShiftTarget
  }

  if (metric.name === 'INP') {
    const { interactionTarget, interactionType } = (metric as INPMetricWithAttribution).attribution
    body.target = interactionTarget
    body.interactionType = interactionType
  }

  navigator.sendBeacon(ENDPOINT, JSON.stringify(body))
}

export function ObservabilityWebVitals() {
  useEffect(() => {
    onCLS(sendVital)
    onINP(sendVital)
    onLCP(sendVital)
    onFCP(sendVital)
    onTTFB(sendVital)
  }, [])

  return null
}
